import { Grid, Collapse } from '@mui/material';
import { Asterisk, FieldLabel } from 'components/modals/addPostModal/PostDetailsForm';
import { PropsWithChildren } from 'react';
type FieldWrapperProps = {
  disabled?: boolean;
  id: string;
  label: string;
  required?: boolean;
};
function FieldWrapper({
  children,
  disabled = false,
  id,
  label,
  required = false,
}: PropsWithChildren<FieldWrapperProps>) {
  if (children) {
    return (
      <Grid container spacing={2} mb={2} alignItems="center">
        <Grid item xs={12} sm={6}>
          <FieldLabel htmlFor={id} disabled={disabled}>
            {label}
            {required && <Asterisk>*</Asterisk>}
          </FieldLabel>
        </Grid>
        <Grid item xs={12} sm={6}>
          {children}
        </Grid>
      </Grid>
    );
  }
  return null;
}
export default FieldWrapper;
